import { IFromOutput, IFromSubmitOutput } from "@types";
import gate from "../gate";
import client from "../http-clients/api";

const formApi = {
  getForm: (slug: string) =>
    gate.get<IFromOutput, never, never>({
      client,
      url: `/form/${slug}`,
    }),
  submit: (id: number, data: Record<string, any>) =>
    gate.file<IFromSubmitOutput, Record<string, any>, never>({
      client,
      url: `/form/submit/${id}`,
      data,
    }),
};

export default formApi;
